export const text = {
  airdrop: {
    preFarmingEligibilityMessage:
      'USDS and DAI borrowers with volatile assets and ETH depositors will be eligible for a future ⚡\u00A0SPK airdrop.',
  },
} as const
